import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import MapPage from '@app/components/ManageAreas/ManageAreasComponent';


const ManageAreasPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Areas</PageTitle>
      <MapPage />
    </>
  );
};

export default ManageAreasPage;
